import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  padding = 'md',
  variant = 'default',
  className = '',
  hoverable = false,
  bordered = true,
  shadow = true,
  animate = false,
  ...props 
}) => {
  const variants = {
    default: 'card-default bg-white',
    glass: 'card-glass bg-white/70 backdrop-blur-xl border-white/20',
    dark: 'card-dark bg-[#0F172A] text-white',
    gradient: 'card-gradient bg-gradient-to-br from-[#2563EB] to-[#1D4ED8] text-white', // changed to blue only
    // neon removed - had purple
    // neon: 'card-neon bg-gradient-to-br from-[#EC4899] to-[#8B5CF6] text-white', // ❌ REMOVED
    success: 'card-success bg-gradient-to-br from-[#10B981] to-[#059669] text-white',
    subtle: 'card-subtle bg-[#F8FAFC]',
    info: 'card-info bg-gradient-to-br from-[#3B82F6] to-[#2563EB] text-white' // added blue info
  };

  const paddings = {
    none: 'p-0',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-10'
  };

  const borderClass = bordered ? 'border border-[#E2E8F0]' : '';
  const shadowClass = shadow ? 'card-shadow' : '';
  const hoverClass = hoverable ? 'card-hover' : '';
  const animateClass = animate ? 'card-animate' : '';

  return (
    <div 
      className={`rounded-2xl transition-all duration-300 ${variants[variant]} ${paddings[padding]} ${borderClass} ${shadowClass} ${hoverClass} ${animateClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

// Sub-components
Card.Header = ({ children, className = '', icon: Icon }) => (
  <div className={`flex items-center justify-between mb-5 ${className}`}>
    <div className="flex items-center gap-3">
      {Icon && (
        <div className="card-header-icon">
          <Icon className="w-5 h-5" />
        </div>
      )}
      {children}
    </div>
  </div>
);

Card.Title = ({ children, className = '' }) => (
  <h3 className={`text-lg font-semibold text-[#0F172A] tracking-tight ${className}`}>{children}</h3>
);

Card.Subtitle = ({ children, className = '' }) => (
  <p className={`text-sm text-[#64748B] ${className}`}>{children}</p>
);

Card.Body = ({ children, className = '' }) => (
  <div className={`${className}`}>{children}</div>
);

Card.Footer = ({ children, className = '' }) => (
  <div className={`mt-6 pt-6 border-t border-[#E2E8F0] ${className}`}>{children}</div>
);

Card.Actions = ({ children, className = '' }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>{children}</div>
);

Card.Badge = ({ children, className = '' }) => (
  <div className={`card-badge ${className}`}>{children}</div>
);

export default Card;